export enum ExtraPrograms {
  childrensLiturgy = "Children's Liturgy",
  yaLiturgy = 'Young Adults Liturgy',
  marriagePrep = 'Marriage Prep',
  rcia = 'RCIA',
}
